Namespace 'Common.Dashboard.Charts'

class Common.Dashboard.Charts.CustomChartCreatorView extends Backbone.View
  template: JST['backbone/templates/common/dashboard/charts/custom_chart_creator/custom_chart_creator']
  className: 'custom-chart-creator'

  events:
    'click #cancel': '_closeModal'
    'click #add-chart': '_addChart'
    'change #chart_type': '_setChartType'
    'change #dimension': '_updateTitle'
    'change #cross_dimension': '_updateTitle'

  initialize: (@session) ->
    @single_dimensions = @_createDimensions()
    @heatmap_dimensions = @_createDimensions()

  render: ->
    @$el.html @template
      chartTypes: @_chartTypes()

    @_setChartType()
    @

  _chartTypes: ->
    [
      {
        value: 'bar',
        title: I18n.t('monitoring.dashboard.charts.bar')
      },
      {
        value: 'column',
        title: I18n.t('monitoring.dashboard.charts.column')
      },
      {
        value: 'pie',
        title: I18n.t('monitoring.dashboard.charts.pie')
      }
    ]

  _createDimensions: ->
    widgetDimensions = Common.WidgetDimensions
    translator = new Common.WidgetDimensionTranslator()
    dimensions = [
      {
        value: widgetDimensions.GROUP
        title: translator.translate(widgetDimensions.GROUP)
      },
      {
        value: widgetDimensions.FILTERED_GROUP,
        title: translator.translate(widgetDimensions.FILTERED_GROUP)
      },
      {
        value: widgetDimensions.SUBTYPE,
        title: translator.translate(widgetDimensions.SUBTYPE)
      },
      {
        value: widgetDimensions.TICKET_STATUS,
        title: translator.translate(widgetDimensions.TICKET_STATUS)
      },
      {
        value: widgetDimensions.ASSIGNED_OPERATOR
        title: translator.translate(widgetDimensions.ASSIGNED_OPERATOR)
      },
      {
        value: widgetDimensions.ASSIGNED_GROUP
        title: translator.translate(widgetDimensions.ASSIGNED_GROUP)
      }
    ]

    @_fixedStringAttributes().forEach((attribute) ->
      dimensions.push({
        value: attribute.get('code'),
        title: translator.translate(widgetDimensions.TAXONOMIC_ATTRIBUTE, {
          attributeName: attribute.get('name')
        }),
        dimensionType: widgetDimensions.TAXONOMIC_ATTRIBUTE
      })
      if attribute.get('multiple')
        dimensions.push({
          value: "filtered_#{attribute.get('code')}",
          title: translator.translate(widgetDimensions.FILTERED_TAXONOMIC_ATTRIBUTE, {
            attributeName: attribute.get('name')
          }),
          dimensionType: widgetDimensions.FILTERED_TAXONOMIC_ATTRIBUTE
        })
    )

    @_hierachicalTagsAttributes().forEach((attribute) ->
      dimensions.push({
        value: attribute.get('code'),
        title: translator.translate(widgetDimensions.HIERARCHICAL_ATTRIBUTE, {
          attributeName: attribute.get('name')
        }),
        dimensionType: widgetDimensions.HIERARCHICAL_ATTRIBUTE
      })
    )

    dimensions

  _setChartType: ->
    chartType = @_selectedChartType()
    if (chartType == 'heatmap')
      @_setHeatmapChart()
    else
      @_setSingleDimensionChart()

    @_renderChartPreview(chartType)

  _setSingleDimensionChart: ->
    @$el.find('.cross_dimension').addClass('hidden')
    @_setDimensions(@single_dimensions)
    @_updateTitleSingle()

  _setHeatmapChart: ->
    @$el.find('.cross_dimension').removeClass('hidden')
    @_setDimensions(@heatmap_dimensions)
    @_setCrossDimensions(@heatmap_dimensions)
    @_updateTitleHeatmap()

  _setDimensions: (dimensions) ->
    dimensionsList = @$el.find('#dimension')

    dimensionsList.empty()

    for dimension in dimensions
      el = document.createElement("option")
      el.value = dimension.value
      el.textContent = dimension.title
      dimensionsList.append(el)

  _setCrossDimensions: (dimensions) ->
    dimensionsList = @$el.find('#cross_dimension')

    dimensionsList.empty()

    for dimension in dimensions
      el = document.createElement("option")
      el.value = dimension.value
      el.textContent = dimension.title
      dimensionsList.append(el)

  _updateTitle: ->
    chartType = @_selectedChartType()
    if (chartType == 'heatmap') then @_updateTitleHeatmap() else @_updateTitleSingle()

  _updateTitleSingle: ->
    selectedDimensionValue = @_selectedDimension()
    selectedDimensionTitle = @single_dimensions.find((dimension) -> dimension.value == selectedDimensionValue).title
    @_titleEl().val(selectedDimensionTitle)

  _updateTitleHeatmap: ->
    selectedDimensionValue = @_selectedDimension()
    selectedDimensionTitle = @heatmap_dimensions.find((dimension) -> dimension.value == selectedDimensionValue).title

    selectedCrossDimensionValue = @_selectedCrossDimension()
    selectedCrossDimensionTitle = @heatmap_dimensions.find((dimension) -> dimension.value == selectedCrossDimensionValue).title

    @_titleEl().val("#{selectedCrossDimensionTitle} by #{selectedDimensionTitle}")

  _renderChartPreview: (chartType) ->
    chartOptions = new Common.Dashboard.PreviewChartOptions().chartOptions(chartType)
    new Highcharts.Chart($.extend(true, chartOptions, @_chartOptions()))

  _addChart: ->
    chartType = @_selectedChartType()
    if (chartType == 'heatmap')
      selectedDimensionValue = @_selectedDimension()
      selectedDimension = @heatmap_dimensions.find((dimension) -> dimension.value == selectedDimensionValue)

      selectedCrossDimensionValue = @_selectedCrossDimension()
      selectedCrossDimension = @heatmap_dimensions.find((dimension) -> dimension.value == selectedCrossDimensionValue)

      widgetOptions =
        title: @_titleEl().val()
        chart_type: chartType,
        type: 'cross_dimension_chart',
        dimension: selectedDimension.dimensionType || selectedDimension.value,
        cross_dimension: selectedCrossDimension.dimensionType || selectedCrossDimension.value,
        definition_code: @_definitionCode(selectedDimension),
        cross_definition_code: @_definitionCode(selectedCrossDimension)

      @session.addWidget(widgetOptions)
    else
      selectedDimensionValue = @_selectedDimension()
      selectedDimension = @single_dimensions.find((dimension) -> dimension.value == selectedDimensionValue)

      widgetOptions =
        title: @_titleEl().val()
        chart_type: chartType,
        type: 'single_dimension_chart',
        dimension: selectedDimension.dimensionType || selectedDimension.value,
        definition_code: @_definitionCode(selectedDimension)

      @session.addWidget(widgetOptions)

    @_closeModal()

  _definitionCode: (selectedDimension) ->
    return null unless selectedDimension.dimensionType
    selectedDimension.value.replace('filtered_', '')

  _selectedChartType: ->
    @$el.find('#chart_type').val()

  _selectedDimension: ->
    @$el.find('#dimension').val()

  _selectedCrossDimension: ->
    @$el.find('#cross_dimension').val()

  _titleEl: ->
    @$el.find('#title')

  _filteredTitle: (title) ->
    "#{title} (#{I18n.t('customer_visual_mode.filters.filtered')})"

  _fixedStringAttributes: ->
    @session.accountAttributes.customAttributes.models.filter((attribute) -> attribute.isFixedString())

  _hierachicalTagsAttributes: ->
    @session.accountAttributes.customAttributes.models.filter((attribute) -> attribute.isHierarchicalTags())

  _chartOptions: ->
    chart:
      width: 688
      height: 300
      renderTo: @$el.find('.chart-preview')[0]

  _closeModal: ->
    @trigger('modal:close')
